import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";
import {
    TeaserDownloadTileTemplate,
    TeaserDownloadTileGridTemplate,
} from "./teaser-download-tile.templates";

export default {
    title: "Components/Teaser Download Tile",
    component: "ux-iws-teaser-download-tile",
    render: TeaserDownloadTileTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        exampleTitle: { table: { disable: true } },
        exampleDescription: { table: { disable: true } },
        exampleImage: { table: { disable: true } },
    },
};

export const AsLink = {
    args: {
        link: "./mock-assets/images/downloads/example-122x172.png",
        exampleTitle: getDummyText(60),
        exampleDescription: getDummyText(240),
        exampleImage: "./mock-assets/images/downloads/example-122x172.png",
    },
};

export const AsLinkWithTag = {
    args: {
        ...AsLink.args,
        tags: "Whitepaper",
    },
};

export const AsDownload = {
    args: {
        ...AsLink.args,
        fileInfo: "25.01.2025 – 460 kB",
        download: "example-122x172.png",
        tags: "Whitepaper,PDF",
    },
};

export const TeaserDownloadGrid = {
    render: TeaserDownloadTileGridTemplate.bind({}),
    args: {},
};
